
































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { router } from '@/router';
import FilterComponent from '@/components/filter.vue';
import { projectService } from '@/services';
import { Export, Operators } from '@/models';
import moment from 'moment';

@Component({
  components: {
    FilterComponent
  }
})
export default class ProjectListPage extends Vue {
  project = this.$store.state.project;
  application = this.$store.state.application;
  lookup = this.$store.state.lookup;
  account = this.$store.state.account;
  dialog = false;
  exportColumns = Export.projectColumns;
  allColumns = true;
  startedOnShown = false;
  endedOnShown = false;
  dialogDelete = false;
  searchProvider = '';
  searchGrantProgram = '';
  searchResponsibleFaculty = '';
  searchState = '';
  searchRole = '';
  startedOnFilter = {
    value: null,
    operator: 0
  };
  endedOnFilter = {
    value: null,
    operator: 0
  };
  projectToDelete: any = null;

  get headers() {
    const columns: any = [
      { text: this.$t('project.list.name'), value: 'name', width: '15%' },
      { text: this.$t('project.list.startedOn'), value: 'startedOn', width: '10%' },
      { text: this.$t('project.list.endedOn'), value: 'endedOn', width: '10%' },
      { text: this.$t('project.list.provider'), value: 'provider', width: '13%', sortable: false },
      { text: this.$t('project.list.grantProgram'), value: 'grantProgram', width: '12%', sortable: false },
      { text: this.$t('project.list.responsibleFaculty'), value: 'responsibleFaculty', width: '15%', sortable: false },
      { text: this.$t('project.list.state'), value: 'state', width: '10%', sortable: false },
      { text: this.$t('project.list.role'), value: 'role', width: '10%', sortable: false }
    ];

    if (this.isAdmin) {
      columns.push({ text: this.$t('project.list.actions'), value: 'actions', sortable: false, align: 'center' });
    }

    return columns;
  }

  get operators() {
    return Operators.filter.map(item => {
      return { ...item, label: this.$t(`filter.operators.${item.code}`) };
    });
  }

  get projects(): [] {
    return this.$store.getters['project/getProjects']();
  }

  get totalCount(): [] {
    return this.$store.getters['project/getTotalCount']();
  }

  get filterValues() {
    const lookups = Object.keys(this.project.search.filter)
      .filter((key: string) => (this.project.search.filter as any)[key] && key !== 'startedOn' && key !== 'endedOn')
      .map(key => {
        return (this.project.search.filter as any)[key].map((item: any) => {
          item.filterName = key;
          return item;
        });
      })
      .flatMap(a => a)
      .map((item: any) => {
        return {
          lookup: this.$store.getters['lookup/getLookupDetail'](item.parentId),
          filterName: item.filterName,
          value: item.value,
          key: item.key
        };
      });

    if (this.project.search.filter.startedOn) {
      lookups.push({
        lookup: this.$t('project.list.startedOn'),
        value: `${this.$t(`filter.operators.${this.project.search.filter.startedOn.operator}`)} ${moment(String(this.project.search.filter.startedOn.value)).format('DD.MM.YYYY')}`,
        filterName: 'startedOn',
        key: 'startedOn'
      });
    }

    if (this.project.search.filter.endedOn) {
      lookups.push({
        lookup: this.$t('project.list.endedOn'),
        value: `${this.$t(`filter.operators.${this.project.search.filter.endedOn.operator}`)} ${moment(String(this.project.search.filter.endedOn.value)).format('DD.MM.YYYY')}`,
        filterName: 'endedOn',
        key: 'endedOn'
      });
    }

    return lookups;
  }
  onPage(page: number): void {
    const el = this.$el.getElementsByClassName('header')[0];

    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }

    this.project.search.actualPage = page;
    this.loadProjects();
  }
  onSort(field: any): void {
    this.project.search.orderBy = field[0];
    this.loadProjects();
  }
  onSortDesc(desc: any): void {
    this.project.search.orderByAsc = !desc[0];
    this.loadProjects();
  }
  onItemsPerPage(field: any): void {
    this.project.search.pageRows = field === -1 ? this.project.totalCount : field;
    this.loadProjects();
  }

  created(): void {
    this.loadProjects();
  }

  loadProjects(): void {
    this.searchProvider = '';
    this.searchGrantProgram = '';
    this.searchResponsibleFaculty = '';
    this.searchState = '';
    this.searchRole = '';
    const searchQuery = this.project.search;

    this.$store.dispatch('project/getAll', searchQuery);
  }

  selectProject(event: any): void {
    this.$store.dispatch('project/clearProject');
    router.push(`/projekt/${event.id}`);
  }

  setStartedOn() {
    this.project.search.filter.startedOn = this.startedOnFilter;
    this.loadProjects();
    this.startedOnShown = false;
  }

  setEndedOn() {
    this.project.search.filter.endedOn = this.endedOnFilter;
    this.endedOnShown = false;
    this.loadProjects();
  }

  removeEndedOn() {
    this.endedOnFilter = { operator: 0, value: null };
    this.project.search.filter.endedOn = null;
    this.loadProjects();
    this.endedOnShown = false;
  }

  removeStartedOn() {
    this.startedOnFilter = { operator: 0, value: null };
    this.project.search.filter.startedOn = null;
    this.loadProjects();
    this.startedOnShown = false;
  }

  setFilter(event: any) {
    this.project.search.filter = event;

    this.loadProjects();
  }

  removeFilter(filterName: string, key: string) {
    if (key === 'startedOn') {
      this.removeStartedOn();
    } else if (key === 'endedOn') {
      this.removeEndedOn();
    } else {
      this.project.search.filter[filterName] = this.project.search.filter[filterName].filter((item: any) => item.key !== key);
      this.loadProjects();
    }
  }

  exportToExcel() {
    const columnsToExport = this.allColumns ? null : this.exportColumns.filter(column => column.selected);
    projectService.exportTo(this.project.search, columnsToExport);
    this.dialog = false;
  }

  selectAllColumns() {
    if (this.allColumns) {
      this.exportColumns.forEach(column => {
        column.selected = true;
      });
    }
  }

  columnSelected() {
    this.allColumns = this.exportColumns.filter(column => !column.selected).length === 0;
  }

  clearSelected() {
    this.exportColumns.forEach(column => {
      column.selected = false;
    });

    this.allColumns = false;
  }

  deleteItem(item: any) {
    this.projectToDelete = item;
    this.dialogDelete = true;
  }

  closeDelete() {
    this.projectToDelete = null;
    this.dialogDelete = false;
  }

  deleteItemConfirm() {
    if (this.projectToDelete) {
      this.$store.dispatch('project/deleteProject', { id: this.projectToDelete.id });
      this.projectToDelete = null;
    }
    this.dialogDelete = false;
  }

  get isExportDisabled() {
    return this.exportColumns.filter(column => column.selected).length === 0;
  }

  get isAdmin() {
    return true; //this.account.user.user.role === 'Administrator';
  }

  async loadItems(id: number) {
    this.$store.dispatch('lookup/getAvailableLookup', id);
  }

  getLookup(id: number) {
    return this.$store.getters['lookup/getAvailableLookupDetail'](id);
  }
}
